/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios'
import { getDreamaWebAppUrl } from '@/constants/domain'
import { DEFAULT_APP_ROUTE } from '@/constants/routes'
import { useUserStore } from '@/stores/user'
import { isDev } from '@/utils/env'
const apiProxyTarget = import.meta.env.VITE_API_PROXY_TARGET
const baseURL = isDev() ? '/api' : apiProxyTarget
console.log('import.meta', import.meta.env)
// 创建axios实例
const request = axios.create({
  baseURL,
  timeout: 80000, // 请求超时时间(毫秒)
  withCredentials: false, // 认证通过 Header (Authorization + uid) 完成，不需要 Cookie
  headers: {
    'Content-Type': 'application/json',
    c: 'h5',
    env: 'ideaflow',
    pg: '7',
  },
})

// request拦截器 - 从store获取用户信息
request.interceptors.request.use(
  (config: any) => {
    const userStore = useUserStore()
    const token = userStore.getToken()
    const id = userStore.getId()
    if (token) {
      config.headers.Authorization = 'metatube-' + token
    }
    if (id) {
      config.headers.uid = id
    }
    return config
  },
  (error: any) => {
    // 对请求错误做些什么
    return Promise.reject(error)
  },
)

// response 拦截器
request.interceptors.response.use(
  (response: any) => {
    // 对响应数据做点什么
    console.log('response===', response)
    return response.data
  },
  (error: any) => {
    // 对响应错误做点什么
    console.log('error===', error)
    const response = error.response
    console.log('response22===', response)

    // 当服务端返回 /loginerr 时，本地执行退出登录并刷新页面
    if (response?.data?.path === '/loginerr') {
      const userStore = useUserStore()
      userStore.clearUserInfo().then(() => {
        window.location.replace(getDreamaWebAppUrl(DEFAULT_APP_ROUTE))
      })
    }

    return Promise.reject(error)
  },
)
export default request
